<template>
    <Wrapper1 />
    <Wrapper2 />
    <Wrapper3 />
    <Wrapper4 />
    <Wrapper5 />
    <Wrapper6 />
    <Teleport to=".container">
        <FixedNav />
        <BindPop ref="bindRef" />
        <LoginPop ref="loginRef" />
    </Teleport>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, onMounted, provide } from "vue";
import Wrapper1 from "./wrapper1";
import Wrapper2 from "./wrapper2";
import Wrapper3 from "./wrapper3";
import Wrapper4 from "./wrapper4";
import Wrapper5 from "./wrapper5";
import BindPop from "@/components/pop-bind.vue";
import LoginPop from "@/components/pop-login.vue";
import FixedNav from "@/components/fixed-nav.vue";
import { GetStatus, GetMyInfo, GetSearchBrother } from "@/api";
import useStore from "@/store/store.js";
const { user, teams, teamname } = storeToRefs(useStore());

const bindRef = ref(null);
const loginRef = ref(null);
const status = ref(false);

onMounted(async () => {
    await getStatus();
    await getMyInfo();
});

// 页面状态
const getStatus = async () => {
    const res = await GetStatus();
    if (!res) {
        CsGame.pageClose();
        return Promise.reject("页面关闭");
    }
    status.value = true;
};

// 获取用户信息
const getMyInfo = async () => {
    const res = await GetMyInfo();
    if (res) {
        user.value = res;
        if (!res.islogin) {
            window.addEventListener("message", (event) => {
                if (event.data.type && event.data.type === "success") {
                    CsGame.alert("登录成功！", 1200, "success");
                    loginRef.value.Hide();
                    getMyInfo();
                }
                if (event.data.type && event.data.type === "fail") {
                    CsGame.alert("登录失败！,请重新登录", 1200, "error");
                    loginRef.value.Refresh();
                }
            });
        } else {
            // 有id获取我的团员列表
            if (res.cur_team_id) {
                const data = await GetSearchBrother(res.cur_team_id);
                if (data) {
                    teams.value = data.list;
                    teamname.value = data.team_name;
                }
            } else {
                teams.value = [];
            }
            window.addEventListener("message", null);
        }
    }
};

provide("loginRef", loginRef);
provide("bindRef", bindRef);
provide("getMyInfo", getMyInfo);
</script>

<style lang="scss" scoped></style>
